import ApplicationOptionSelector from "../../../components/application/ApplicationOptionSelector";
import { CAPEVActivityModeHelp } from "../../../activities/cape-v/CAPEVControlContextualHelp";
import CatalogLaunchConfigurationPreferenceNote from "./CatalogLaunchConfigurationPreferenceNote";

export default function CatalogEntryLaunchConfigurationSelector({
  entry,
  selectedLaunchConfigurationId,
  availableLaunchConfigurations = [],
  onChange,
  showPreferenceControl = false
}) {
  if (!entry || availableLaunchConfigurations.length <= 1) {
    return null;
  }

  const selectedConfiguration =
    availableLaunchConfigurations.find((configuration) =>
      configuration.id === selectedLaunchConfigurationId
    ) || availableLaunchConfigurations[0];

  return (
    <div className="catalog-detail__launch-configuration-selector">
      <ApplicationOptionSelector
        id={`catalog-launch-configuration-${entry.slug}`}
        label="Activity mode"
        labelAside={(
          <CAPEVActivityModeHelp
            availableLaunchConfigurations={availableLaunchConfigurations}
          />
        )}
        value={selectedConfiguration.id}
        onChange={onChange}
        options={availableLaunchConfigurations.map((configuration) => ({
          value: configuration.id,
          label: configuration.label
        }))}
        note={showPreferenceControl ? (
          <CatalogLaunchConfigurationPreferenceNote
            entry={entry}
            selectedConfiguration={selectedConfiguration}
          />
        ) : null}
      />
    </div>
  );
}
